import { useEffect, useState } from "react";
import { CalendarDays, Newspaper } from "lucide-react";
import { TerminalShell } from "@/components/TerminalShell";
import { TradingViewEmbed } from "@/components/TradingViewEmbed";
import { useAuth } from "@/context/AuthContext";
import { useLanguage } from "@/context/LanguageContext";

const TABS = [
  { key: "events", labelKey: "calendar.events", icon: CalendarDays },
  { key: "news", labelKey: "calendar.news", icon: Newspaper },
];

const EVENTS_CONFIG = {
  locale: "br",
  countryFilter: "ar,au,br,ca,cn,fr,de,in,id,it,jp,kr,mx,ru,sa,za,tr,gb,us,eu",
  importanceFilter: "0,1",
};

const NEWS_CONFIG = { displayMode: "adaptive", feedMode: "all_symbols", locale: "br" };

export default function CalendarPage() {
  const { t: tr } = useLanguage();
  const { user } = useAuth();
  const [tab, setTab] = useState("events");
  const [height, setHeight] = useState(620);

  useEffect(() => {
    const onResize = () => setHeight(window.innerWidth < 768 ? 640 : 700);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <TerminalShell account={user?.name}>
      <div data-testid="calendar-page" className="space-y-5 p-4 sm:p-6">
        <div>
          <h1 className="font-heading text-2xl font-light tracking-tight text-white">{tr("calendar.title")}</h1>
          <p className="mt-1 text-sm text-[#8A97AD]">{tr("calendar.subtitle")}</p>
        </div>

        <div className="flex gap-2 rounded-md border border-[#141A26] bg-[#0A0E16] p-1">
          {TABS.map((t) => (
            <button
              key={t.key}
              data-testid={`calendar-tab-${t.key}`}
              onClick={() => setTab(t.key)}
              className={`flex flex-1 items-center justify-center gap-2 rounded px-3 py-2 text-xs uppercase tracking-[0.15em] transition-colors ${
                tab === t.key ? "bg-[#132038] text-[#5B9CFF]" : "text-[#8A97AD] hover:text-white"
              }`}
            >
              <t.icon className="h-3.5 w-3.5" /> {tr(t.labelKey)}
            </button>
          ))}
        </div>

        {tab === "events" ? (
          <TradingViewEmbed
            testId="economic-calendar-widget"
            script="embed-widget-events.js"
            config={EVENTS_CONFIG}
            height={height}
            copyright="Track all markets on TradingView"
          />
        ) : (
          <TradingViewEmbed
            testId="market-news-widget"
            script="embed-widget-timeline.js"
            config={NEWS_CONFIG}
            height={height}
            copyright="Top stories by TradingView"
          />
        )}
      </div>
    </TerminalShell>
  );
}
